import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CompanyInfo } from '../../classes/company-info';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../classes/company';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';

@Component({
  selector: 'app-company-info-page',
  templateUrl: './company-info-page.component.html',
  styleUrls: ['./company-info-page.component.scss']
})
export class CompanyInfoPageComponent implements OnInit {

  constructor(
    private router: Router,
    private UserService: UserService,
    private route: ActivatedRoute,
    private CompanyService: CompanyService
  ) { }

  companyInfo: CompanyInfo = <CompanyInfo>{};
  submitting: boolean;
  orgs: any;
  completedForm: boolean;
  orgId: number;
  msg: string;
  signUpMsg: string;
  repeat: number;
  cnameFocus: boolean = false;
  numEmpFocus: boolean = false;
  healthFocus: boolean = false;
  @ViewChild('signUpErrorModal') signUpErrorModal: ModalComponent;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.repeat = +params['repeatSignUp'];
      if (this.repeat == 2) {
        this.signUpErrorModal.open();
      }

      if (localStorage.onboardingToken) {
        this.UserService.getUserInfo()
          .subscribe(u => {
            let user = JSON.parse(u.user);
            this.companyInfo.employee_number = user.employee_number;
            this.companyInfo.health_benefits = user.health_benefits;
          })
      }


    })
  }

  submitInfo(companyInfoform: NgForm) {
    this.submitting = true;
    this.msg = '';
    if (companyInfoform.invalid) {
      return;
    }

    let user = this.UserService.getSignUpUser();
    user.company_name = this.companyInfo.company_name;
    user.health_benefits = this.companyInfo.health_benefits;
    user.employee_number = +this.companyInfo.employee_number;
    if (this.repeat == 1) {
      this.CompanyService.addCompany(<Company>{ company: this.companyInfo.company_name })
        .subscribe(res => {
          let org = JSON.parse(res.organization).id;
          window.analytics.track("Self-Signup Company Registraion Submitted",{OrgId: org, employees: this.companyInfo.employee_number, benefits: this.companyInfo.health_benefits });
          this.router.navigate(['/onboarding/dashboard/multiple', org]);
        }, err => {
            window.analytics.track("Self-Signup Company Registraion Submission Failed",{employees: this.companyInfo.employee_number, benefits: this.companyInfo.health_benefits, reason: JSON.parse(JSON.parse(err._body).flash)[0][1]});
            this.signUpMsg = JSON.parse(JSON.parse(err._body).flash)[0][1];
            if (this.signUpMsg == 'Employee number must be less than or equal to 20') {
              this.router.navigate(['/onboarding/companyinfo', 2])
            }
            else{
              this.msg = JSON.parse(JSON.parse(err._body).flash)[0][1];
            }
        })
    }
    else {
      this.UserService.signUp(user)
        .subscribe(res => {
          this.router.navigate(['/', 1, user.email]);
          window.analytics.track("Self-Signup Company Registraion Submitted");
        }, err => {
          this.msg = JSON.parse(JSON.parse(err._body).flash)[0][1];
          window.analytics.track("Self-Signup Company Registraion Submission Failed");
          if (this.msg == 'Employee number must be less than or equal to 20') {
            this.router.navigate(['/onboarding/companyinfo', 2])
          }
        })

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-info-page/company-info-page.component.ts